module.exports = __webpack_public_path__ + "img/image26.96be9ee4.png";